// Port of api/fuel/app/classes/filter/package/games/play.php
import PlayersData from 'offline/filter/package/games/play/data/players'
import GameContextData from 'offline/filter/package/games/play/data/games/context'
import GameCountsData from 'offline/filter/package/games/play/data/games/counts'
import GameGroupPlayersData from 'offline/filter/package/games/play/data/games/players/group'
import GameUserPlayersData from 'offline/filter/package/games/play/data/games/players/user'
import GameWinPercentData from 'offline/filter/package/games/play/data/games/winpercent'
import GroupPlaysData from 'offline/filter/package/games/play/data/plays/group'
import UserPlaysData from 'offline/filter/package/games/play/data/plays/user'

import PreviousPrepare from 'offline/filter/package/games/play/prepare/previous'
import GameCountsPrepare from 'offline/filter/package/games/play/prepare/games/counts'
import GameGroupPlayersPrepare from 'offline/filter/package/games/play/prepare/games/players/group'
import GameUserPlayersPrepare from 'offline/filter/package/games/play/prepare/games/players/user'
import GameWinPercentPrepare from 'offline/filter/package/games/play/prepare/games/winpercent'

import PlayPackage from 'offline/filter/package/games/play/package/play'
import PlayersPackage from 'offline/filter/package/games/play/package/players'
import PlaysPackage from 'offline/filter/package/games/play/package/plays'
import GameCountsPackage from 'offline/filter/package/games/play/package/games/counts'
import GameGroupPlayersPackage from 'offline/filter/package/games/play/package/games/players/group'
import GameUserPlayersPackage from 'offline/filter/package/games/play/package/games/players/user'
import GameWinPercentPackage from 'offline/filter/package/games/play/package/games/winpercent'

function sortUnits(units) {
	return units.slice().sort(function(a, b) {
		return (a.priority || 0) - (b.priority || 0)
	})
}

function runPrepare(units, local, global, config, filter) {
	var prepared = Object.assign({}, local)
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(prepared, global, config, filter)
		if (result !== undefined) prepared = result
	}

	return prepared
}

function runPackage(units, prepared, global, config, filter) {
	var pkg = {}
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(pkg, prepared, global, config, filter)
		if (result !== undefined) pkg = result
	}

	return pkg
}

export default {
	data_units: [
		PlayersData,
		GameContextData,
		GameCountsData,
		GameGroupPlayersData,
		GameUserPlayersData,
		GameWinPercentData,
		GroupPlaysData,
		UserPlaysData
	],

	prepare_units: [
		PreviousPrepare,
		GameCountsPrepare,
		GameGroupPlayersPrepare,
		GameUserPlayersPrepare,
		GameWinPercentPrepare
	],

	package_units: [
		PlayPackage,
		PlayersPackage,
		PlaysPackage,
		GameCountsPackage,
		GameGroupPlayersPackage,
		GameUserPlayersPackage,
		GameWinPercentPackage
	],

	run: function(resultId, local, global, config, filter) {
		var prepared = runPrepare(this.prepare_units, local, global, config, filter)
		var pkg = runPackage(this.package_units, prepared, global, config, filter)
		pkg.id = resultId
		return pkg
	}
}
